import React, { FC } from "react"
import { BenefitEnrollmentFlowModal } from "../views/modal/BenefitEnrollmentFlow/BenefitEnrollmentFlowModal"
import { Workflows } from "./workflow/workflows"
import { Steps } from "./workflow/steps"
import { benefitEnrollmentSteps, benefitEnrollmentWorkflows } from "./workflow/benefitEnrollmentFlowStateMachine"

// <old>
import { useSelector } from "react-redux"
import { Workflows as OldWorkflows } from "../views/modal/BenefitEnrollmentFlow/Workflow/Workflows"
import { Steps as OldSteps } from "../views/modal/BenefitEnrollmentFlow/Workflow/Steps"
import {
  benefitEnrollmentSteps as oldBenefitEnrollmentSteps,
  benefitEnrollmentWorkflows as oldBenefitEnrollmentWorkflows
} from "../views/modal/BenefitEnrollmentFlow/Workflow/BenefitEnrollmentFlowStateMachine"
import {
  getCompanyHasCarrotSpecificDeductibleEnabled,
  getCompanyHasExternallyManagedDeductibleEnabled
} from "derivedSelectors/deductibleSelectors"
// </old>

import { StateMachineProvider } from "components/context/stateMachine/StateMachineContext"
import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"
import { useFeatureToggle } from "components/context/feature-toggle/FeatureToggleContext"

interface BenefitEnrollmentFlowContainerProps {
  onExit: () => void
}

const BenefitEnrollmentFlowContainer: FC<BenefitEnrollmentFlowContainerProps> = ({ onExit }) => {
  const { showNewEnrollmentFlow } = useFeatureToggle()
  const stateMachineProps = showNewEnrollmentFlow
    ? {
        initialStep: Steps.INFORMATIONAL,
        workflows: benefitEnrollmentWorkflows,
        steps: benefitEnrollmentSteps,
        stateMachineName: "EnrollmentFlowV2",
        workflowName: GetWorkflow()
      }
    : {
        initialStep: OldSteps.INFORMATIONAL,
        workflows: oldBenefitEnrollmentWorkflows,
        steps: oldBenefitEnrollmentSteps,
        stateMachineName: "EnrollmentFlowV2",
        workflowName: GetOldWorkflow()
      }
  return (
    <StateMachineProvider {...stateMachineProps} handleWorkflowComplete={onExit}>
      <BenefitEnrollmentFlowModal onExit={onExit} />
    </StateMachineProvider>
  )
}

const GetWorkflow = () => {
  const { companyHasCSDEnabled, companyIsExternalOnly } = useBenefitEnrollment()
  console.log("Dark Release: Partner CSD")
  return companyHasCSDEnabled
    ? Workflows.CSD
    : companyIsExternalOnly
    ? Workflows.ACA_EXTERNAL_ONLY
    : Workflows.NO_CSD_PLUS_ACA
}

const GetOldWorkflow = () => {
  const companyHasCSDEnabled = useSelector(getCompanyHasCarrotSpecificDeductibleEnabled)
  const companyIsExternalOnly = useSelector(getCompanyHasExternallyManagedDeductibleEnabled)

  return companyHasCSDEnabled
    ? OldWorkflows.CSD
    : companyIsExternalOnly
    ? OldWorkflows.ACA_EXTERNAL_ONLY
    : OldWorkflows.NO_CSD_PLUS_ACA
}

export { BenefitEnrollmentFlowContainer }
